import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
//import './index.css'
import { PrimeReactProvider } from 'primereact/api'
import "primereact/resources/themes/mira/theme.css"
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'

createRoot(document.getElementById('info-map-2')).render(
  <PrimeReactProvider>
		<App />
	</PrimeReactProvider>
)
